import BybButton from "@Components/common/byb-ds/buttons/byb-button";
import { Box, Paper, Stack } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const OverlayRoot = styled(Box)({
  position: "absolute",
  top: 12,
  right: 12,
  bottom: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: 8,
  pointerEvents: "none",
});

export const ToggleButton = styled(BybButton, {
  shouldForwardProp: prop => prop !== "active",
})<{ active: boolean }>(({ active, theme }) => ({
  pointerEvents: "auto",
  boxShadow: "none",
  minWidth: 136,
  height: 40,
  paddingInline: theme.spacing(1.75),
  padding: theme.spacing(0.85, 1.75),
  borderRadius: theme.spacing(1.25),
  fontVariantNumeric: "tabular-nums",
  borderWidth: 1,
  borderStyle: "solid",
  whiteSpace: "nowrap",
  flexShrink: 0,
  borderColor: active ? theme.palette.dsPrimary.v300 : alpha(theme.palette.dsBase.v200, 0.12),
  backgroundColor: active ? theme.palette.dsPrimary.v300 : alpha(theme.palette.dsBase.v100, 0.92),
  color: active ? theme.palette.dsBase.v100 : theme.palette.dsBase.v200,
  "& .MuiTypography-root": {
    color: active ? theme.palette.dsBase.v100 : theme.palette.dsBase.v200,
    whiteSpace: "nowrap",
  },
  "&:hover": {
    boxShadow: "none",
    borderColor: active ? theme.palette.dsPrimary.v400 : alpha(theme.palette.dsBase.v200, 0.16),
    backgroundColor: active ? theme.palette.dsPrimary.v400 : alpha(theme.palette.dsBase.v100, 0.98),
  },
  "&:active": {
    boxShadow: "none",
    borderColor: active ? theme.palette.dsPrimary.v400 : alpha(theme.palette.dsBase.v200, 0.16),
    backgroundColor: active ? theme.palette.dsPrimary.v400 : alpha(theme.palette.dsBase.v100, 0.98),
  },
  "&:disabled .MuiTypography-root": {
    color: active ? theme.palette.dsBase.v100 : theme.palette.dsBase.v200,
  },
  "&:disabled": {
    opacity: 1,
    borderColor: active ? theme.palette.dsPrimary.v300 : alpha(theme.palette.dsBase.v200, 0.12),
    backgroundColor: active ? theme.palette.dsPrimary.v300 : alpha(theme.palette.dsBase.v100, 0.92),
  },
}));

export const CardsStack = styled(Stack)({
  pointerEvents: "auto",
  width: 248,
  overflowY: "auto",
});

export const DecisionCardSurface = styled(Paper, {
  shouldForwardProp: prop => prop !== "accentColor",
})<{ accentColor: string }>(({ accentColor, theme }) => ({
  padding: theme.spacing(1.6, 1.75),
  width: 248,
  color: theme.palette.dsBase.v200,
  backgroundColor: alpha(theme.palette.dsBase.v100, 0.96),
  border: `1px solid ${alpha(theme.palette.dsBase.v200, 0.07)}`,
  borderLeft: `6px solid ${accentColor}`,
  borderRadius: theme.spacing(2),
  boxShadow: "none",
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    border: `1px solid ${alpha(accentColor, 0.28)}`,
    pointerEvents: "none",
  },
}));

export const CardHeader = styled(Stack)({
  justifyContent: "space-between",
  alignItems: "center",
});

export const MetricsGroup = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 7.6,
});

export const MetricRow = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  columnGap: 22,
});

export const MetricCell = styled(Stack)({
  minWidth: 0,
  alignItems: "flex-start",
  gap: 0.8,
});
